// Homepage Analytics carousel: one large horizontal slide at a time.
// Uses native scrollLeft/scrollTo rather than CSS transform — transform-based
// sliding was unreliable in testing (same compositing issue seen on the
// mobile nav menu), scrollTo is native browser behavior and just as smooth.
// The scrollbar itself is hidden via CSS so it still reads as a slider, not
// a raw scroll area.
export function initAnalyticsSlider() {
	const root = document.querySelector('[data-analytics-slider]');
	if (!root) return;

	const viewport = root.querySelector('.analytics-slider__viewport');
	const track = root.querySelector('.analytics-slider__track');
	const slides = [...track.children];
	const prevBtn = root.querySelector('[data-analytics-prev]');
	const nextBtn = root.querySelector('[data-analytics-next]');
	const dotsContainer = root.querySelector('[data-analytics-dots]');

	if (slides.length <= 1) {
		if (prevBtn) prevBtn.hidden = true;
		if (nextBtn) nextBtn.hidden = true;
		return;
	}

	let index = 0;
	let syncing = false;

	slides.forEach((_, i) => {
		const dot = document.createElement('button');
		dot.type = 'button';
		dot.className = 'analytics-slider__dot';
		dot.setAttribute('aria-label', `Slide ${i + 1}`);
		dot.addEventListener('click', () => goTo(i));
		dotsContainer.appendChild(dot);
	});
	const dots = [...dotsContainer.children];

	function render() {
		dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
		if (prevBtn) prevBtn.disabled = index === 0;
		if (nextBtn) nextBtn.disabled = index === slides.length - 1;
	}

	function goTo(i) {
		index = Math.max(0, Math.min(slides.length - 1, i));
		syncing = true;
		viewport.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
		render();
		window.setTimeout(() => { syncing = false; }, 500);
	}

	if (prevBtn) prevBtn.addEventListener('click', () => goTo(index - 1));
	if (nextBtn) nextBtn.addEventListener('click', () => goTo(index + 1));

	// Keep dots/arrows in sync if the user scrolls/swipes the viewport directly.
	let scrollTimer;
	viewport.addEventListener('scroll', () => {
		if (syncing) return;
		window.clearTimeout(scrollTimer);
		scrollTimer = window.setTimeout(() => {
			const nearest = slides.reduce((best, slide, i) => {
				const dist = Math.abs(slide.offsetLeft - viewport.scrollLeft);
				return dist < best.dist ? { i, dist } : best;
			}, { i: 0, dist: Infinity });
			index = nearest.i;
			render();
		}, 100);
	});

	render();
}
